module.exports = __webpack_public_path__ + "media/images/client_logos/logo_moet_hennessy_200-6c73c34f6c457ed56734779881ca2acb.png";